export const analyticTypes = [
    {
        name: gettext('Revenue by plan and currency'),
        slug: 'revenue-by-plan-and-currency',
        group: 'Transactions',
        rendererName: 'Table',
        cols: ['currency'],
        rows: ['name'],
        vals: ['amount', 'amount'],
        aggregatorName: 'Sum',
    },
    {
        name: gettext('Revenue by plan and currency broken to year and month'),
        slug: 'revenue-by-plan-and-currency-broken-to-year-and-month',
        group: 'Transactions',
        rendererName: 'Table',
        cols: ['name', 'currency'],
        rows: ['year', 'month'],
        vals: ['amount', 'amount'],
        aggregatorName: 'Sum',
    },
    {
        name: gettext('Plot historical totals by year'),
        slug: 'plot-historical-sums-by-year',
        rendererName: 'Stacked Column Chart',
        plotlyOptions: {legend: {"orientation": "h"}, autosize: true,  width: "100%",title: {text: gettext('Historical totals by year')}},
        plotlyConfig: {responsive: true},
        group: 'Transactions',
        cols: ['year',],
        rows: ['name', 'currency'],
        vals: ['amount', 'amount'],
        aggregatorName: 'Sum',
        rowOrder: "value_z_to_a",
    },
    {
        name: gettext('Plot historical totals by year/month'),
        slug: 'plot-historical-sums-by-year-month',
        rendererName: 'Stacked Column Chart',
        plotlyOptions: {legend: {"orientation": "h"}, autosize: true, width: "100%", title: {text: gettext('Historical totals by year/month')}},
        plotlyConfig: {responsive: true},
        group: 'Transactions',
        cols: ['year', 'month'],
        rows: ['name', 'currency'],
        vals: ['amount', 'amount'],
        aggregatorName: 'Sum',
        rowOrder: "value_z_to_a",
    },
]